"use client";
import Image from "next/image";
import { useEffect, useState } from "react";
import closeIcon from "@/assets/images/icons/navbar/close.svg";

interface TickerBannerProps {
  message: string;
  actionText?: string;
  actionUrl?: string;
  heroSectionId?: string;
}

const canShowTickBanner = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("tickBannerHidden") !== "true";
  }
  return true;
};

const TickerBanner: React.FC<TickerBannerProps> = ({
  message,
  actionText = "",
  actionUrl = "",
  heroSectionId = "hero-section",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Ensure this only runs on the client
    setIsClient(true);
    setIsVisible(canShowTickBanner());

    const handleScroll = () => {
      const heroSection = document.getElementById(heroSectionId);
      if (!heroSection) return;
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      const isInHeroSection = heroBottom > 0 && canShowTickBanner();
      setIsVisible(isInHeroSection);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [heroSectionId]);

  const onBannerClose = () => {
    setIsVisible(false);
    if (typeof window !== "undefined") {
      localStorage.setItem("tickBannerHidden", "true");
    }
  };
  if (!isClient || !isVisible) {
    return null;
  }

  return (
    <div className="fixed top-[72px] z-40 flex w-full items-center justify-center bg-gradient-to-r from-[#781E8F] to-[#422CBB] py-2 text-center lg:top-[71px]">
      <div className="container relative mx-auto">
        <div className="flex flex-wrap items-center justify-center px-4">
          <p className="text-[12px] font-medium text-white lg:text-[14px]">
            {message}
            {actionText && (
              <a href={actionUrl} className="ml-2 bg-gradient-to-r border border-dashed border-gray-500 from-[#781E8F] to-[#422CBB] hover:border-white text-white px-2 py-1 rounded-full">
                {actionText}
              </a>
            )}
          </p>
        </div>
      </div>
      <button className="absolute right-2 lg:right-4" onClick={onBannerClose}>
        <Image src={closeIcon} alt="Close banner" width={24} height={24} />
      </button>
    </div>
  );
};

export default TickerBanner;
